import {useRealtimeSubscription} from "@/api/realtime/RealtimeChannelHooks.ts";
import {BackupCreationProgressEvent, RestoreProgressEvent} from "@/backup/RestoreProgress.ts";

export function useBackupCreationRealtime(
    jobId: string | undefined,
    listener: (event: BackupCreationProgressEvent) => void,
) {
    useRealtimeSubscription(jobId ? `/backup-creation/${jobId}` : undefined, listener);
}

export function useBackupRestoreRealtime(
    jobId: string | undefined,
    listener: (event: RestoreProgressEvent) => void,
) {
    useRealtimeSubscription(jobId ? `/restore/${jobId}` : undefined, listener);
}
